import styles from './styles.module.scss';
import clsx from 'clsx';

type InputProps = {
  src: string;
  className?: string;
  responsive?: boolean;
};

export const CompanyLogo = ({
  src,
  className,
  responsive = false,
}: InputProps) => {
  return (
    <div className={clsx(styles.root, className)}>
      <div
        className={clsx(styles.logo, responsive && styles.responsive)}
        style={{
          backgroundImage: `url('${src}')`,
        }}
      ></div>
    </div>
  );
};
